import React, { useEffect, useState } from 'react';
import './styles.scss';
import UserForm from './forms/userForm';
import Loading from '../../components/loading';
import CompanyForm from './forms/companyForm';
import { useDispatch, useSelector } from 'react-redux';
import { setAlert } from '../../redux/dashboard/actions';
import utils from '../../utils';
import API from '../../services/api';
import { getRegisterStep, getUser } from '../../redux/user/actions';

const RegistrationContainer = ({ registrationStep }) => {
  const [step, setStep] = useState(registrationStep);
  const [isLoading, setIsLoading] = useState(false);
  const [user, setUser] = useState(null);
  const [accessToken, setAccessToken] = useState(null);

  const dispatch = useDispatch();

  const loggedUser = useSelector(getUser);
  const registerStep = useSelector(getRegisterStep);

  const isBrand = loggedUser?.type === 'BRAND' || user?.type === 'BRAND';
  useEffect(() => {
    if (isBrand) window.location.hash = '#/charts';
  }, [isBrand]);

  useState(() => {
    setUser(loggedUser || null);
    setAccessToken(loggedUser?.accessToken || null);
    setStep(registerStep || 1);
  }, []);

  if (isBrand) return null;

  if (isLoading) {
    return (
      <div className="registration-container">
        <Loading size={32} />
      </div>
    );
  }

  const errorRedirect = () => {
    setTimeout(() => {
      window.location.hash = '#/login';
    }, 3000);
  };

  const sitesRedirect = () => {
    setIsLoading(true);
    // If you need to dispatch user, do it here
    API.setAccessToken(accessToken);
    dispatch({ type: 'SET_LOADING', payload: true });
    dispatch({ type: 'SET_USER', payload: user });
    setTimeout(() => {
      if (user.type === 'BRAND') {
        window.location.hash = '#/charts';
      } else {
        window.location.hash = '#/sites';
      }
    }, 3000);
  };

  return (
    <div className="registration-container">
      {isLoading ? (
        <Loading size={32} />
      ) : (
        <>
          {step === 1 && (
            <UserForm
              onSuccess={info => {
                setUser(info.user);
                setAccessToken(info.accessToken);
                setStep(2);
                dispatch({ type: 'REGISTER_STEP', payload: 2 });
              }}
              onError={error => {
                if (error.code === 13) {
                  dispatch(setAlert(utils.generateAlert('User already exists, try to login instead', 'error')));
                } else {
                  dispatch(setAlert(utils.generateAlert('Registration failed', 'error')));
                }
                errorRedirect();
              }}
              onLoading={setIsLoading}
            />
          )}
          {step === 2 && (
            <CompanyForm
              user={user}
              accessToken={accessToken}
              onSuccess={() => {
                sitesRedirect();
              }}
              onError={message => {
                dispatch(setAlert(utils.generateAlert(message, 'error')));
                errorRedirect();
              }}
              onLoading={setIsLoading}
            />
          )}
        </>
      )}
    </div>
  );
};

export default RegistrationContainer;
